// @flow

import React, { Component }   from 'react';
import { connect }            from 'react-redux';
import { Link }               from 'react-router-dom';
import moment                 from 'moment';
import { getTranslate }       from 'react-localize-redux';
import StylishDropdown        from 'components/common/stylishDropdown/stylishDropdown';
import CalculatorBestPackage  from './calculatorBestPackage';
import './calculator.css';

class Calculator extends Component {

  sdChangeCallback = null;

  state = {
    dropdownItems     : [],
    currentApplication: null
  }

  componentDidMount = () => {
    const { apps } = this.props;

    if( apps ) {
      const { rows } = apps;
      rows.forEach((item, key) => {
        this.setState(prevState => ({
          dropdownItems: [...prevState.dropdownItems,
            { id: rows[key].id,
              value: rows[key].order_id,
              order_id: rows[key].order_id,
              text:  'ID: ' + item.order_id + ' | Dato: ' + moment(item.created_at).format('DD/MM/YYYY'),
              url: '' }]
        }));
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if( nextProps.currentApp !== this.props.currentApp ) {
      this.setState({ currentApplication: nextProps.currentApp });
    }
  }

  render() {
    const { translate, currentApp }             = this.props;
    const { dropdownItems, currentApplication } = this.state;

    // If there is set current application, we need to change
    // first item in dropdown label
    var firstItemLabel = '';
    if( dropdownItems && dropdownItems.length && currentApp ) {
      firstItemLabel = 'ID: ' + currentApp.order_id + ' | Dato: ' + moment(currentApp.created_at).format('DD/MM/YYYY');
    }

    return (
      <div className="calculator">
        <div className="application">
          <h2>{translate('calculator.heading_2')}</h2>
          <div className="search-bar">
            <form>
              <div className="row">
                <div className="col-md-6 col-xs-12 pull-right text-right">
                  <label htmlFor="lbl-04">{translate('common.active_applications')}</label>
                  <StylishDropdown items={dropdownItems} label={firstItemLabel} changeCallback={this.props._callbackSetApplication} />
                </div>
              </div>
            </form>
          </div>
          <div className="products-area type2">
            <div>
              <header className="calc-heading">
                <nav className="tabset">
                  <ul className="nav-tabs">
                    <li className="active"><Link to='#tab-bestpackage' data-toggle='tab' aria-expanded='true' className='allRounded'>{translate('calculator.tabs.best_package')}</Link></li>
                  </ul>
                </nav>
              </header>
              <div className="tab-content">
                <div role="tabpanel" className="tab-pane fade active in" id="tab-bestpackage">
                {currentApplication &&
                  <CalculatorBestPackage />
                }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate   : getTranslate(state.locale),
  apps        : state.application.applications,
  currentApp  : state.application.activeApplication
});

export default connect(mapStateToProps)(Calculator);



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/calculator.js